export const legalContent = {
  'how-it-works': {
    title: 'How it works',
    text: `Step 1: Search hotels using our intuitive search bar to find the perfect stay for your destination and dates.
Step 2: Compare options, including prices, amenities, and guest reviews, to make the best choice for your needs.
Step 3: Book easily in just a few clicks and receive instant confirmation to your email.
Our goal is to make the booking process simple, transparent, and stress-free so you can focus on enjoying your trip.`
  },
  terms: {
    title: 'Terms & Conditions',
    text: `This demo project does not provide real booking services. All content is presented for educational and demonstration purposes only.
By using this site, you agree that any data entered is not stored permanently and does not result in actual hotel reservations.
We reserve the right to modify, update, or remove content without prior notice.
For real bookings, please use verified travel platforms.`
  },
  support: {
    title: 'Support',
    text: `Need help or have questions? Contact us at support@startover.com.
Our support team is available during standard business hours to answer your inquiries.
Although this project is only a demo, we are happy to guide you through how the platform works or assist with technical issues.
For urgent travel-related matters, please contact official hotel providers directly.`
  },
  privacy: {
    title: 'Privacy Policy',
    text: `We value your privacy. This demo project does not collect, store, or process any personal data beyond temporary form inputs.
No information is shared with third parties or used for marketing purposes.
If you choose to submit any information, it will not be retained after the session ends.
This ensures a safe and anonymous experience while browsing.`
  },
  cookies: {
    title: 'Cookie Policy',
    text: `This project does not use cookies or similar tracking technologies.
Unlike real booking platforms, no browsing activity is saved or analyzed for personalization.
Your session remains entirely private, and no data is stored on your device after leaving the page.
This allows you to explore the demo freely without concerns about tracking.`
  }
};
